import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BulkAction } from "../../../../../../shared/grid/bulk-actions/bulk-action.model";
import { ArrayHelper } from "../../../../../../utilities/contracts/array-helper";
import { IChartMetadata } from "../../../../../api/chart-lake/charts-list-response.model";
import { CopyChartService } from "../../../../../api/copy-chart/copy-chart.service";
import { ChartRouteFilters } from "./chart-route-filter.model";

@Component({
    selector: "member-detail-body-grids-charts",
    templateUrl: "./member-detail-body-grids-charts.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MemberDetailBodyGridsChartsComponent implements OnInit {
    actions: BulkAction[] = [];
    filters: any = {};
    routeParameters: ChartRouteFilters = null;
    hideFilterItems = true;
    showAttachChartToChaseModal = false;
    chartDetail: IChartMetadata;

    constructor(
        private route: ActivatedRoute,
        private readonly cd: ChangeDetectorRef,
        private chartService: CopyChartService) { }

    ngOnInit() {
        this.actions = [
            new BulkAction({
                name: "Attach Chart(s) to Chase",
                action: this.attachCharts.bind(this),
                alwaysEnabled: true,
                showBulkAction: false,
            }),
        ];
        const memberId = this.route.snapshot.paramMap.get("memberId");
        this.filters = { ...this.filters, memberId };
        this.routeParameters = new ChartRouteFilters(memberId ?? "");
    }

    onMemberChartsGridSelectionChange(event: any): void {
        this.actions = [...this.actions];
    }

    attachCharts(selectedCharts): void {
        if (!ArrayHelper.isAvailable(selectedCharts)) {
            return;
        }
        this.chartDetail = selectedCharts;
        this.showAttachChartToChaseModal = true;
        this.cd.detectChanges();
    }

    onCancel(): void {
    this.showAttachChartToChaseModal = false;
    this.cd.markForCheck();
  }
}
